import styled from 'styled-components'

export const ButtonLabel = styled.span`
  font-size: 14px;
  line-height: 16px;
  margin-left: 8px;
  font-weight: normal;
`
